export type EventMediaKind = "photo" | "voice" | "thumbnail";

const getFileExtensionFromType = (mimeType: string, fallback: string): string => {
  const fromMime = mimeType.split("/")[1]?.replace("jpeg", "jpg");
  return fromMime || fallback;
};

const getFileExtension = (file: File, fallback: string): string => (
  file.name.includes(".")
    ? file.name.split(".").pop() || getFileExtensionFromType(file.type, fallback)
    : getFileExtensionFromType(file.type, fallback)
);

export const mediaPaths = {
  buildEventMediaPath(params: {
    eventSlug: string;
    deviceCode: string;
    mediaId: string;
    file: File;
    kind: EventMediaKind;
  }): string {
    const { eventSlug, deviceCode, mediaId, file, kind } = params;
    const fallback = kind === "voice" ? "webm" : "jpg";
    const extension = getFileExtension(file, fallback);
    return `events/${eventSlug}/originals/${deviceCode}/${mediaId}.${extension}`;
  },

  buildThumbnailPath(params: { eventSlug: string; mediaId: string }): string {
    const { eventSlug, mediaId } = params;
    return `events/${eventSlug}/thumbs/${mediaId}.jpg`;
  },

  buildZipPath(params: { eventSlug: string; jobToken: string }): string {
    const { eventSlug, jobToken } = params;
    return `events/${eventSlug}/zips/${jobToken}/current.zip`;
  },
};
